<template>
  <ul class="flex items-center gap-4">
    <li>
      <a
        href="https://www.facebook.com/deDierenbescherming/"
        :title="$t('footer.db-on-social-media-facebook')"
        target="_blank"
        class="hover:text-app-green transform transition duration-200 ease-in-out"
      >
        <AtomIconAppFacebook class="w-6" />
      </a>
    </li>
    <li>
      <a
        href="https://twitter.com/dierbescherming"
        :title="$t('footer.db-on-social-media-twitter')"
        target="_blank"
        class="hover:text-app-green transform transition duration-200 ease-in-out"
      >
        <AtomIconAppXFormerlyKnownAsTwitter class="w-6" />
      </a>
    </li>
    <li>
      <a
        href="https://www.linkedin.com/company/de-dierenbescherming"
        :title="$t('footer.db-on-social-media-linkedin')"
        target="_blank"
        class="hover:text-app-green transform transition duration-200 ease-in-out"
      >
        <AtomIconAppLinkedIn class="w-6" />
      </a>
    </li>
    <li>
      <a
        href="https://www.instagram.com/dierenbescherming/"
        :title="$t('footer.db-on-social-media-instagram')"
        target="_blank"
        class="hover:text-app-green transform transition duration-200 ease-in-out"
      >
        <AtomIconInstagram class="w-6" />
      </a>
    </li>
    <li>
      <a
        href="https://bsky.app/profile/dierenbescherming.nl"
        :title="$t('footer.db-on-social-media-bluesky')"
        target="_blank"
        class="hover:text-app-green transform transition duration-200 ease-in-out"
      >
        <AtomIconBluesky class="w-6" />
      </a>
    </li>
  </ul>
</template>
